import { SxProps } from "@mui/material";

export const sxGreenTextButton: SxProps = {
  fontFamily: 'Unimed-Sans',
  textTransform: 'none',
  fontWeight: 600,
  padding: '4px',
  fontSize: '16px',
  color: '#00995d',
}